(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-purchase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__cgCartRedirectBound) return;
    window.__cgCartRedirectBound = true;

    const wait = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

    const showError = (form, message) => {
      let error = form.querySelector('.cg-cart-redirect__error');
      if (!error) {
        error = document.createElement('p');
        error.className = 'cg-cart-redirect__error';
        error.setAttribute('role', 'alert');
        error.setAttribute('aria-live', 'assertive');
        form.prepend(error);
      }
      error.textContent = message;
    };

    const addToCart = async (form) => {
      const formData = new FormData(form);
      formData.delete('return_to');
      const baseUrl = window.routes?.cart_add_url || '/cart/add';
      const requestUrl = `${baseUrl.replace(/\.js$/, '')}.js`;
      const requestOptions = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
        credentials: 'same-origin',
      };

      let response = await fetch(requestUrl, requestOptions);
      if (response.status === 429) {
        await wait(450);
        response = await fetch(requestUrl, requestOptions);
      }
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'We could not add this item. Please try again.');
      }

      try {
        window.TuMandoGiftAutoAdd?.reconcile?.();
      } catch (_) {
        // The complimentary gift can reconcile again on the cart page.
      }
    };

    document.addEventListener(
      'submit',
      async (event) => {
        const form = event.target?.closest?.('form[data-cg-cart-redirect="true"]');
        if (!form) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.dataset.cgCartSubmitting === 'true') return;

        const submitButton = event.submitter || form.querySelector('[type="submit"][name="add"]');
        form.dataset.cgCartSubmitting = 'true';
        submitButton?.setAttribute('aria-busy', 'true');
        submitButton?.setAttribute('aria-disabled', 'true');
        if (submitButton) submitButton.disabled = true;

        try {
          await addToCart(form);
          window.location.assign(window.routes?.cart_url || '/cart');
        } catch (error) {
          showError(form, error.message || 'We could not add this item. Please try again.');
          form.dataset.cgCartSubmitting = 'false';
          submitButton?.removeAttribute('aria-busy');
          submitButton?.removeAttribute('aria-disabled');
          if (submitButton) submitButton.disabled = false;
        }
      },
      true,
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crazy-gigi-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeStickyCart = (bar) => {
      if (!bar || bar.dataset.stickyInitialized === 'true') return;
      bar.dataset.stickyInitialized = 'true';

      const variantInput = bar.querySelector('[data-sticky-variant]');
      const quantityInput = bar.querySelector('[data-sticky-quantity]');
      const submitButton = bar.querySelector('[data-sticky-submit]');
      const submitLabel = bar.querySelector('[data-sticky-submit-label]');
      const price = bar.querySelector('[data-sticky-price]');
      const comparePrice = bar.querySelector('[data-sticky-compare-price]');
      const availability = bar.querySelector('[data-sticky-availability]');
      const availabilityLabel = bar.querySelector('[data-sticky-availability-label]');
      const variantsScript = bar.querySelector('[data-sticky-variants]');
      const mainSection = document.getElementById('cg-purchase');
      const mainForm = mainSection ? mainSection.querySelector('.cg-purchase__form') : null;
      const mainVariant = mainForm ? mainForm.querySelector('[name="id"]') : null;
      const mainQuantity = mainForm ? mainForm.querySelector('[name="quantity"]') : null;
      const productId = String(bar.dataset.productId || '');
      const variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
      const variantMap = new Map(variants.map((variant) => [String(variant.id), variant]));
      let editorSelected = false;
      let frameRequested = false;
      let synchronizing = false;

      const selectedVariantId = () => String(variantInput ? variantInput.value : '');

      const updateVariant = (variantId) => {
        const variant = variantMap.get(String(variantId));
        if (!variant) {
          if (submitButton) submitButton.disabled = true;
          if (submitLabel) submitLabel.textContent = bar.dataset.unavailableButtonLabel;
          return;
        }

        if (price) price.textContent = variant.price;
        if (comparePrice) {
          comparePrice.textContent = variant.compare_price;
          comparePrice.hidden = !variant.compare_price;
        }
        if (availability) availability.classList.toggle('is-unavailable', !variant.available);
        if (availabilityLabel) {
          availabilityLabel.textContent = variant.available
            ? bar.dataset.availableText
            : bar.dataset.unavailableText;
        }
        if (submitButton) submitButton.disabled = !variant.available;
        if (submitLabel) {
          submitLabel.textContent = variant.available
            ? bar.dataset.buttonLabel
            : bar.dataset.soldOutLabel;
        }
      };

      const syncFromMain = () => {
        if (synchronizing) return;
        synchronizing = true;
        if (mainVariant && variantInput && mainVariant.value) {
          variantInput.value = mainVariant.value;
          updateVariant(mainVariant.value);
        }
        if (mainQuantity && quantityInput && mainQuantity.value) {
          quantityInput.value = mainQuantity.value;
        }
        synchronizing = false;
      };

      const syncToMain = () => {
        if (synchronizing) return;
        synchronizing = true;
        if (mainVariant && variantInput && variantInput.value) {
          mainVariant.value = variantInput.value;
          mainVariant.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (mainQuantity && quantityInput && quantityInput.value) {
          mainQuantity.value = quantityInput.value;
          mainQuantity.dispatchEvent(new Event('input', { bubbles: true }));
        }
        synchronizing = false;
      };

      const redirectToCartAfterAdd = (event) => {
        if (event.detail?.data?.didError) return;
        if (event.detail?.data?.source !== 'product-form-component') return;
        if (productId && String(event.detail?.data?.productId || '') !== productId) return;
        if (bar.dataset.cartRedirectPending === 'true') return;
        bar.dataset.cartRedirectPending = 'true';
        window.location.assign(window.routes?.cart_url || '/cart');
      };

      const triggerElement = () => {
        if (!mainSection) return null;
        if (bar.dataset.triggerMode === 'purchase_form') {
          return mainSection.querySelector('.cg-purchase__form') || mainSection;
        }
        return mainSection;
      };

      const updateVisibility = () => {
        frameRequested = false;
        const trigger = triggerElement();
        const always = bar.dataset.triggerMode === 'always';
        const top = Number.parseFloat(getComputedStyle(bar).top) || 0;
        const triggerOffset = Number.parseFloat(bar.dataset.triggerOffset) || 0;
        const passedTrigger = trigger
          ? trigger.getBoundingClientRect().bottom <= top + triggerOffset
          : always;
        const visible = editorSelected || always || passedTrigger;

        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };

      const requestVisibilityUpdate = () => {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(updateVisibility);
      };

      if (variantInput) {
        variantInput.addEventListener('change', () => {
          updateVariant(selectedVariantId());
          syncToMain();
        });
      }
      if (quantityInput) quantityInput.addEventListener('input', syncToMain);
      if (mainVariant) mainVariant.addEventListener('change', syncFromMain);
      if (mainQuantity) mainQuantity.addEventListener('input', syncFromMain);

      window.__cgStickyCartDrawerListeners ||= new Map();
      const previousDrawerListener = window.__cgStickyCartDrawerListeners.get(bar.dataset.sectionId);
      if (previousDrawerListener) document.removeEventListener('cart:update', previousDrawerListener);
      window.__cgStickyCartDrawerListeners.set(bar.dataset.sectionId, redirectToCartAfterAdd);
      document.addEventListener('cart:update', redirectToCartAfterAdd);

      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId !== bar.dataset.sectionId) return;
        editorSelected = true;
        bar.classList.add('is-editor-selected');
        updateVisibility();
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId !== bar.dataset.sectionId) return;
        editorSelected = false;
        bar.classList.remove('is-editor-selected');
        updateVisibility();
      });

      window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
      window.addEventListener('resize', requestVisibilityUpdate);

      syncFromMain();
      updateVariant(selectedVariantId());
      updateVisibility();
    };

    document.querySelectorAll('[data-cg-sticky-cart]').forEach(initializeStickyCart);

    document.addEventListener('shopify:section:load', (event) => {
      const bar = event.target.querySelector('[data-cg-sticky-cart]');
      if (bar) initializeStickyCart(bar);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-explore-20260720"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-anniversary-bar-20260922"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tm-anniversary-bar')) {
    customElements.define('tm-anniversary-bar', class extends HTMLElement {
      connectedCallback() {
        this.updateStickyHeight = () => {
          const height = this.closest('.tm-anniversary-section')?.getBoundingClientRect().height || 0;
          document.documentElement.style.setProperty('--tm-announcement-height', `${height}px`);
        };
        this.updateStickyHeight();
        this.stickyResizeObserver = new ResizeObserver(this.updateStickyHeight);
        this.stickyResizeObserver.observe(this.closest('.tm-anniversary-section') || this);
        this.cycle = Math.round(Number(this.dataset.cycleSeconds));
        this.start = Date.parse(this.dataset.startAt);
        if (!(this.cycle > 0) || !Number.isFinite(this.start)) return;
        this.clock = this.querySelector('.tm-anniv-notice__clock');
        this.hours = this.querySelector('[data-tm-anniversary-hours]');
        this.minutes = this.querySelector('[data-tm-anniversary-minutes]');
        this.seconds = this.querySelector('[data-tm-anniversary-seconds]');
        this.refresh = () => this.updateCountdown();
        this.updateCountdown();
        this.clock.hidden = false;
        this.interval = window.setInterval(this.refresh, 1000);
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
      }
      disconnectedCallback() {
        this.stickyResizeObserver?.disconnect();
        document.documentElement.style.removeProperty('--tm-announcement-height');
        window.clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }
      updateCountdown() {
        const elapsed = Math.max(0, Date.now() - this.start);
        const duration = this.cycle * 1000;
        const remaining = Math.ceil((duration - elapsed % duration) / 1000);
        this.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
        this.minutes.textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
        this.seconds.textContent = String(remaining % 60).padStart(2, '0');
        this.dataset.remainingSeconds = String(remaining);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-anniversary-carousel-20260916"]) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-anniversary-track]');
    const slides = [...root.querySelectorAll('[data-anniversary-slide]')];
    const dots = [...root.querySelectorAll('[data-anniversary-dot]')];
    const toggle = root.querySelector('[data-anniversary-toggle]');
    const caption = root.querySelector('[data-anniversary-caption]');
    const status = root.querySelector('[data-anniversary-status]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, timer, raf, hover = false, visible = true;
    let paused = root.dataset.autoplay !== 'true' || motion.matches;
    const delay = Math.max(5, Number(root.dataset.interval) || 6) * 1000;
    function schedule() {
      clearTimeout(timer);
      if (!paused && !hover && visible && !document.hidden) timer = setTimeout(() => go(index + 1, false), delay);
    }
    function controls() {
      toggle.setAttribute('aria-label', paused ? root.dataset.playLabel : root.dataset.pauseLabel);
      toggle.querySelector('.tm-anniversary__play').hidden = !paused;
      toggle.querySelector('.tm-anniversary__pause').hidden = paused;
      root.dataset.playing = String(!paused);
      schedule();
    }
    function update() {
      index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      slides.forEach((slide, i) => slide.querySelector('a').tabIndex = i === index ? 0 : -1);
      const slide = slides[index];
      caption.href = slide.querySelector('a').href;
      caption.querySelector('strong').textContent = slide.dataset.product;
      root.dataset.activeSlide = String(index);
      if (paused) status.textContent = slide.getAttribute('aria-label');
    }
    function go(next, manual = true) {
      if (manual) { paused = true; controls(); }
      const target = (next + slides.length) % slides.length;
      track.scrollTo({left: track.clientWidth * target, behavior: motion.matches ? 'instant' : 'smooth'});
      schedule();
    }
    root.querySelector('[data-anniversary-prev]').addEventListener('click', () => go(index - 1));
    root.querySelector('[data-anniversary-next]').addEventListener('click', () => go(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    toggle.addEventListener('click', () => { paused = !paused; controls(); });
    root.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); go(index + (e.key === 'ArrowRight' ? 1 : -1)); }
    });
    root.addEventListener('mouseenter', () => { hover = true; schedule(); });
    root.addEventListener('mouseleave', () => { hover = false; schedule(); });
    root.addEventListener('focusin', e => { if (e.target !== toggle) { paused = true; controls(); } });
    track.addEventListener('pointerdown', () => { paused = true; controls(); }, {passive:true});
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, {passive:true});
    document.addEventListener('visibilitychange', schedule);
    motion.addEventListener('change', () => { if (motion.matches) paused = true; controls(); });
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold:0.15}).observe(root);
    new ResizeObserver(() => { track.scrollTo({left:index * track.clientWidth,behavior:'instant'}); }).observe(track);
    update(); controls();
  }
  document.querySelectorAll('[data-anniversary-carousel]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-anniversary-carousel]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
